import api from "./Api";

class CategoriaEstoqueService {
  GetCategoriaEstoque(payload) {
    return api.get("/v1/categoriaEstoque/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCategoriaEstoque(payload) {
    return api.post("/v1/categoriaEstoque/", payload).then((response) => {
      return response.data;
    });
  }

  PutCategoriaEstoque(payload) {
    return api.put("/v1/categoriaEstoque/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCategoriaEstoque(payload) {
    return api.delete("/v1/categoriaEstoque/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCategoriaEstoqueOData(payload) {
    return api.get("/OData/CategoriaEstoque" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CategoriaEstoqueService();
